import { axiosBase, errorHandler } from "./axios";


const getActivePlans = (page: any, limit: any, mode: string) => {
    console.log("getActivePlans mode:", mode);
    return axiosBase.get(`/api/v1/subscriptions/plans?page=${page}&limit=${limit}&mode=${mode}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}

const viewSubscription = (input: any) => {
    return axiosBase
        .get(`/api/v1/subscriptions/view-subscription/${input}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}

const getCurrentSubscription = (payload?: any) => {
    return axiosBase.get(`/api/v1/subscriptions/summary`, { params: payload ? { payload: payload } : {} })
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}
const updateSubscription = (input: any) => {
    return axiosBase
        .put(`/api/v1/subscriptions/update-subscription`, input)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}


const getSubscriptionHistory = (page: any, limit: any, entityId?: string) => {
    return axiosBase.get(`/api/v1/subscriptions/payments?page=${page}&limit=${limit}&entityId=${entityId}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}

const prepareSubscriptionCheckout = (payload: { planId: string; }) => {
    return axiosBase
        .post("/api/v1/subscriptions/prepare-checkout", payload)
        .then((response) => response.data)
        .catch(errorHandler);
};

const verifySubscriptionPayment = (payload: any) => {
    return axiosBase
        .post("/api/v1/subscriptions/verify-payment", payload)
        .then((response) => response.data)
        .catch(errorHandler);
};

const cancelSubscription = (payload: any) => {
    return axiosBase
        .post("/api/v1/subscriptions/cancel", payload)
        .then((response) => response.data)
        .catch(errorHandler);
}

const checkSubscriptionStatus = (payload: any) => {
    return axiosBase
        .get(`/api/v1/subscriptions/check-subscription-status/${payload}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}

export const subscriptionService = {
    getActivePlans,
    getCurrentSubscription,
    getSubscriptionHistory,
    prepareSubscriptionCheckout,
    verifySubscriptionPayment,
    cancelSubscription,
    viewSubscription, updateSubscription, checkSubscriptionStatus
};